import {attendeeApiClient} from 'attendee/apiClient'
import {FullPageLoader} from 'attendee/theme/FullPageLoader'
import {Transaction} from 'organization/Invoices/Transactions/OrganizationTransactionsProvider'
import React, {useEffect, useState} from 'react'
import {toast} from 'react-toastify'

export interface AttendeeTransactionsContextProps {
  transactions: Transaction[]
  createInvoice: (transaction: Transaction) => Promise<boolean>
}

export const AttendeeTransactionsContext = React.createContext<
  AttendeeTransactionsContextProps | undefined
>(undefined)

export default function AttendeeTransactionsProvider(props: {
  children: React.ReactElement
}) {
  const apiClient = attendeeApiClient()
  const [transactions, setTransactions] = useState<Transaction[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    get()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const get = async () => {
    const response = await apiClient.get(`api/transactions`)
    setTransactions(response)
    setLoading(false)
  }

  const createInvoice = async (transaction: Transaction) => {
    const result = await apiClient
      .post(`api/transactions/create-invoice`, {
        transaction_id: transaction.id,
      })
      .then(get)
      .then(() => {
        return true
      })
      .catch((error) => {
        toast.warning(error.response.data.message)
        return false
      })

    return result
  }

  return (
    <AttendeeTransactionsContext.Provider
      value={{
        transactions,
        createInvoice,
      }}
    >
      {loading && <FullPageLoader />}
      {!loading && props.children}
    </AttendeeTransactionsContext.Provider>
  )
}

export function useAttendeeTransactions() {
  const context = React.useContext(AttendeeTransactionsContext)
  if (context === undefined) {
    throw new Error(
      'useAttendeeTransactions must be used within AttendeeTransactionsProvider',
    )
  }
  return context
}
